package fr.manyverse.app.presentation.layout

import androidx.compose.foundation.layout.widthIn
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

/**
 * Web implementation: Apply 1200.dp maximum width constraint.
 * Content will be centered and constrained for better readability on large screens.
 */
actual fun Modifier.platformMaxWidth(): Modifier {
    return this.widthIn(max = 1200.dp)
}
